import * as React from "react";

import {
  Button,
  useNotify,
  useRefresh,
  useUnselectAll,
  useUpdateMany,
} from "react-admin";

import { Check } from "@material-ui/icons";

const ConfirmButton = ({ selectedIds, ...props }) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const unselectAll = useUnselectAll();
  const [updateMany, { loading }] = useUpdateMany(
    "research-project-evals/confirm",
    selectedIds,
    {},
    {
      onSuccess: () => {
        refresh();
        notify("Posts updated");
        unselectAll("research-project-evals");
      },
      onFailure: (error) =>
        notify("Error: posts not updated", { type: "warning" }),
    }
  );
  return (
    <Button label="ra.action.confirm" disabled={loading} onClick={updateMany}>
      <Check />
    </Button>
  );
};

export default ConfirmButton;
